import { CatalogueRepository } from "@catalogue/data/repositories/catalogue.repository";
import { Service } from "@catalogue/domain/models/service.model";
import { Nullable } from "@core/domain/types/nullable.type";
import { inject, injectable } from "inversify";

@injectable()
export class CreateServiceUseCase {
    constructor(
        @inject(CatalogueRepository)
        private readonly catalogueRepository: CatalogueRepository,
    ) {}

    async execute(service: Omit<Service, "id">): Promise<Nullable<Service>> {
        return this.catalogueRepository.createService(service);
    }
}
